import React from 'react';

import AuthUserContext from './context';
import { withFirebase } from '../Firebase';

const SESSION_WINDOW_MS = 48 * 60 * 60 * 1000;
const getStoredLoginAt = () => {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem('lastLoginAt');
  const parsed = raw ? Number(raw) : NaN;
  return Number.isFinite(parsed) ? parsed : null;
};

const withAuthentication = Component => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);

      const cachedAuthUser = JSON.parse(localStorage.getItem('authUser'));
      const lastLoginAt = getStoredLoginAt();
      if (lastLoginAt && Date.now() - lastLoginAt > SESSION_WINDOW_MS) {
        localStorage.removeItem('authUser');
        localStorage.removeItem('lastLoginAt');
      }

      // Ensure roles property exists
      if (cachedAuthUser && !cachedAuthUser.roles) {
        cachedAuthUser.roles = {};
      }

      this.state = {
        authUser:
          lastLoginAt && Date.now() - lastLoginAt > SESSION_WINDOW_MS ? null : cachedAuthUser,
      };
    }

    componentDidMount() {
      this.listener = this.props.firebase.onAuthUserListener(
        authUser => {
          const lastLoginAt = getStoredLoginAt();
          if (lastLoginAt && Date.now() - lastLoginAt > SESSION_WINDOW_MS) {
            localStorage.removeItem('authUser');
            localStorage.removeItem('lastLoginAt');
            this.setState({ authUser: null });
            this.props.firebase.doSignOut();
            return;
          }
          if (!lastLoginAt) {
            localStorage.setItem('lastLoginAt', String(Date.now()));
          }
          localStorage.setItem('authUser', JSON.stringify(authUser));
          this.setState({ authUser });
        },
        () => {
          localStorage.removeItem('authUser');
          localStorage.removeItem('lastLoginAt');
          this.setState({ authUser: null });
        },
      );
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      return (
        <AuthUserContext.Provider value={this.state.authUser}>
          <Component {...this.props} />
        </AuthUserContext.Provider>
      );
    }
  }

  return withFirebase(WithAuthentication);
};

export default withAuthentication;
